import {
    BackCta,
    Column,
    Icon,
    Link,
    MEDIA,
    MediaStack,
    Row,
    TagText,
    TagTextProps,
    Text,
    Tooltip
} from "@bridgesplit/ui";
import { COPY, LOOPS_SLUG } from "app/constants";
import { doNothing, formatDate } from "@bridgesplit/utils";
import { LoopExpanded, MarketGuideMode, isPtToken } from "@bridgesplit/abf-react";

import { useLoopContext } from "../LoopContext";
import { LoopImage, OpenHowItWorks } from "../../common";

export default function LoopDetailHeader() {
    const { loopExpanded } = useLoopContext();

    const isValidPtToken = isPtToken(loopExpanded?.collateralToken);

    return (
        <Column spacing={2}>
            <Link to={LOOPS_SLUG}>
                <BackCta back={doNothing} backCta={`All ${COPY.LOOP_TERM_PLURAL}`} />
            </Link>

            <Row spaceBetween>
                <Row spacing={2}>
                    <LoopImage offset={-0.25} loopExpanded={loopExpanded} badgeSize="sm" size="lg" />

                    <MediaStack query={MEDIA.MD} spacing={1}>
                        <Text variant="h3">{loopExpanded?.loopVault.name}</Text>
                        {isValidPtToken && (
                            <Tooltip title={"PT Tokens can be redeemed at full value on their maturity date"}>
                                <Row spacing={1}>
                                    <MaturityDateTag loopExpanded={loopExpanded} />
                                </Row>
                            </Tooltip>
                        )}
                    </MediaStack>
                </Row>

                {loopExpanded && (
                    <OpenHowItWorks variant="outlined" mode={MarketGuideMode.Earn} loopExpanded={loopExpanded} />
                )}
            </Row>
        </Column>
    );
}

function MaturityDateTag({ loopExpanded }: { loopExpanded: LoopExpanded | undefined }) {
    const tagText: Partial<TagTextProps> = {
        px: 1.5,
        py: 0.75,
        textVariant: "body2",
        variant: "colored",
        borderRadius: 20
    };

    return (
        <TagText {...tagText}>
            {formatDate(loopExpanded?.loopVault.maturityDate, "date", {
                alwaysShowYear: true,
                showTime: "never"
            })}
            <Icon type="help" />
        </TagText>
    );
}
